<template>
    <div class="login-page">
        <v-card class="login-card pa-8" elevation="3">
            <div class="text-center mb-6">
                <v-img class="mx-auto mb-4" width="110" contain :src="require('@/assets/main-logo.png')" />
                <div class="login-title">Commercial League CMS</div>
                <div class="text-body-2 grey--text">Sign in to continue</div>
            </div>
            <v-expand-transition>
                <v-alert v-if="showAlert" dense text :type="type" class="text-body-2">
                    {{ message }}
                </v-alert>
            </v-expand-transition>
            <login-form @setAlert="setAlert" />
        </v-card>
    </div>
</template>

<script>
    import LoginForm from '@/forms/LoginForm'

    export default {
        components: { LoginForm },
        data() {
            return {
                showAlert: false,
                message: '',
                type: null
            }
        },
        watch: {
            tab: {
                handler(newval, oldval) {
                    if (newval) {
                        if (this.showAlert !== false) {
                            this.showAlert = false
                        }
                    }
                }
            },
            showAlert: {
                handler(newval, oldval) {
                    if (newval !== oldval) {
                        setTimeout(() => { this.showAlert = false }, 7000)
                    }
                }
            }
        },
        created() {
        },
        methods: {
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
            }
        }
    }
</script>

<style scoped>
/* the charcoal of the website, lit by its teal-to-blue gradient */
.login-page {
    min-height: 100vh;
    margin-top: -56px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 16px 10vh;
    background:
        radial-gradient(circle at 85% 10%, rgba(3, 229, 183, 0.28) 0%, rgba(3, 229, 183, 0) 45%),
        radial-gradient(circle at 10% 95%, rgba(3, 122, 222, 0.3) 0%, rgba(3, 122, 222, 0) 50%),
        #232323;
}

.login-card {
    width: 100%;
    max-width: 380px;
    border-top: 4px solid transparent !important;
    border-image: linear-gradient(90deg, #03e5b7 0%, #037ade 74%) 1;
}

.login-title {
    font-family: 'Squada One', Arial, sans-serif;
    font-size: 1.7rem;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #232323;
}
</style>
